export const cloneBalances = (balances) => {
    const result = Object.create(null);
    for (const walletAccount of Object.keys(balances)) {
        const accountBalances = balances[walletAccount];
        const clonedAccount = Object.create(null);
        for (const assetName of Object.keys(accountBalances)) {
            clonedAccount[assetName] = { ...accountBalances[assetName] };
        }
        result[walletAccount] = clonedAccount;
    }
    return result;
};
